    <template>

    <div class="cell large-10">

       <template>

            <div v-if="$mq != 'sm'">

               <div class="grid-x text-center qbordercolour">
                    <div class="cell xlarge-3 show-for-xlarge" style="text-align:left; padding:15px; color:white;">
                        <div style="font-weight:bold; font-size:23px; ">
                        FIND BETTER <br/>BETTING<br/><span style="color:gold">OPPORTUNITES</span>
                        </div>
                        <div style="padding-top: 10px;font-size:13px; color:white;font-weight: 500; margin-right:40px">Compare odds, check our bets, use the site tools and analysis and get the latest free offers</div>
                        <div style="padding-top: 30px;font-size:10px;font-weight: bold;text-align: center;">
                            <span><img class="smallwhiteiconsize" :src="require('/public/assets/icons/bookmaker-whi.png')" alt="Bookmakers" style="margin-right:10px">{{  sitestats.Bookmakers }} </span>
                            <span><img class="smallwhiteiconsize qwhiteicon" :src="require('/public/assets/icons/analytics-whi.png')" alt="Odds" style="margin:0px 10px 00px 10px"> {{ sitestats.Odds }}            </span>
                            
                        </div>
                    
                    
                    </div>
                    <div class="cell large-12 xlarge-9 qbordercolour"><adcarousel v-if="$store.state.countryname!=''"></adcarousel></div>
                
                </div> 
            </div>
           <div v-else>

                <div class="grid-x text-center">
                   <div class="cell small-12" style="background-color: white;"><adcarouselsmall v-if="$store.state.countryname!=''"></adcarouselsmall></div>
                </div>
                <div>
                    <div class="cell small-12" ><blogview view="tickertape"/></div>
                </div>

            </div>
        </template>

        <template>

            <div class="grid-x text-center">

                    <div class="cell" v-if="$mq === 'lg'">
                         <div class="cell large-4"   >
                        <whatwedo orientation="landscape"></whatwedo>
                        </div>
                    </div>


                    <div class="cell promoCard"  style="margin:0px 10px 15px 1px">
                        <menuitems  :templatetype="2"></menuitems>

                    </div>



                   <div class="cell large-8 medium-12">
                        <div class="promoCard" style="margin:1px 10px 50px 10px">
                            <tabs @changed="changeTableView">


                                <div v-for="(row,i) in $store.state.oats" :key="i">

                                    <tab :title=row.D img="" :id=row.id :tabtype="$tabtype.textonly" :requirelogin="row.requirelogin" :description="row.Explanation" v-if="row.showmain" :isactive="row.id==$store.state.selectedoat">

                                        <template v-show="row.id==$store.state.selectedoat">

                                            <dataviews @dvchanged="dvchange" :spname="$store.state.oats[$store.state.selectedoat].param1" :nodays=14 :sportid="sportkeyid"></dataviews>

                                        </template>

                                    </tab>
                                </div>
                            </tabs>
                        </div>

                    </div>

                        <div class="cell auto" style="margin-right:6px" v-if="$mq === 'lg'" >

                            <template v-if="dvloaded && !$store.state.wasSSR" >
                               <div class="cell large-4 show-for-large promoCard"><horsesmouth param1="brief"></horsesmouth></div>
                               <div class="promoCard" style="margin-top:10px;margin-left:2px"><graph searchtype="dateonly" graphtype="Line" :enableMeta="false"></graph></div>

                            </template>


                            <!-- <div style="font-weight:bold;padding-left:20px;padding-right:20px; font-size:medium;height:30px;padding-top:25px">What We Do...</div>  -->
                            <!-- <whatwedo orientation="portrait"></whatwedo> -->


                        </div>

            </div>


        </template>

    </div>
</template>

 <script>
const adcarousel = () => import('../components/adverts/adcarousel.vue');
import dataviews from  '../components/components/dataviews.vue';
const horsesmouth = () => import('../components/features/horsesmouth.vue');
const graph = () => import('../components/components/graph.vue');
import tab from '../components/modified3rdpartycomponents/tab.vue'
import tabs from '../components/modified3rdpartycomponents/tabs.vue'
import menuitems from '../components/components/menuitems.vue';
const adcarouselsmall = () =>  import('../components/adverts/adcarouselsmall.vue');
import blogview from '../components/components/blogview.vue';
const whatwedo = () => import('../components/navigation/whatwedo.vue');


    export default {

name: "home",
metaInfo() {

  return {
    title: "OddsGalore | Betting Odds Analysis",
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: "Compare odds, betting strategies, betting tools, gambling guides, promotional news and bookmaker trivia"
      },
      {
        vmid: 'og:title',
        property: 'og:title',
        content: "OddsGalore | Betting Odds Analysis Site"
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: (process.env.VUE_APP_WEBSITE || '') + (this.$route ? this.$route.fullPath : '/')
      }
    ]
  }
},





     data: function data() {
                return {
                sportkeyid: 0,
                oatloaded: false,
                dvloaded: false,
                sitestats: []
                }
    },
    components: {

        adcarousel,
        dataviews,
        horsesmouth,
        graph,
        tab,
        tabs,
        menuitems,
        adcarouselsmall,
        blogview,
        whatwedo

    },

        async asyncData({ app, localLoader, store, route, isServer }) {

                if (isServer) {
                   this.sitestats = localLoader("sitestats.json")
                }
        },

    created: function created() {

        

        if (typeof window !== 'undefined') {
                let path = process.env.VUE_APP_DATA + "sitestats.json"

                this.localJSONLoad(path).then(response => {

                    this.sitestats = response.data[0]

                }).catch(error => {
                    console.log(error)
                });
        }
    },

    mounted: function mounted() {

           // reset to now and next


             this.$store.commit('setOat', 0);
            if (typeof window !== 'undefined') {
             window.__PRERENDER_READY = true

}

   this.$nextTick(() => {
        this.$meta().refresh();
    });
            },

    methods: {



            changeTableView: function changeTableView(newVal) {

                      //dataview loaded - so graph loads after dataview (as things above)
                      this.dvloaded = false

                      let filteredrows = this.$store.state.oats.filter(row => row.showmain === true);

                      this.$store.commit("setOat",filteredrows[newVal].id);

                },

               refreshTableView: function refreshTableView(newVal) {
                    this.sportkeyid = newVal;
                },



            dvchange: function dvchange(newVal) {

                this.dvloaded=true

            },
             }
    }



</script>

